//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // 选项
    options: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    // 初始化值
    value: {
      default: ''
    }
  },
  data: function data() {
    return {
      setType: this.value
    };
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};